<script setup lang="ts">
  import { TableLoading } from '@/shared/ui';
  import { useHomeSearch } from '../model/useHomeSearch';
  import HomeSearchBar from './HomeSearchBar.vue';
  import RecommendationsTable from './RecommendationsTable.vue';

  const {
    documents,
    loading,
    searchTerm,
    searchCriteria,
    activeItemType,
    handleSearch,
    clearSearch,
  } = useHomeSearch();
</script>

<template>
  <div
    class="h-full flex flex-col"
    data-testid="home-default-view"
  >
    <div class="mt-8 px-6 shrink-0">
      <HomeSearchBar
        class="w-full"
        @search="handleSearch"
        @clear="clearSearch"
      />
    </div>
    <div class="flex-1 px-6">
      <TableLoading
        v-if="loading"
        :row-size="11"
      />
      <RecommendationsTable
        v-else
        :documents="documents"
        :search-term="searchTerm"
        :search-criteria="searchCriteria"
        :active-item-type="activeItemType"
      />
    </div>
  </div>
</template>

<style scoped>
  @media (max-width: 768px) {
    .flex-col {
      gap: 1.5rem;
    }
  }
</style>
